import React from "react";


function ErrorBlock({ error }) {
  return (
    (
      <div className="invalid-feedback" style={{ display: "block" }}>
        {error}
      </div>
    )
  );
}

export default ErrorBlock;
